import api from "./api";

export async function getBrandingDocumentsSettings() {
  const res = await api.get("/tenant/settings/branding-documents");
  return res.data;
}

export async function updateBrandingDocumentsSettings(payload) {
  const res = await api.put("/tenant/settings/branding-documents", payload);
  return res.data;
}
